import React from "react";
import SEO from "../components/SEO";
import { PageHero, SectionHeading, StatCard, CTABand, CheckList, Icon } from "../components/ui-blocks";
import { arCollections as ar, images } from "../mock/mock";

export default function ARDebtCollections() {
  return (
    <>
      <SEO
        title="AR Recovery & Debt Collections — Recover Aging Accounts Receivable"
        description="VerifiAssist follows up, tracks and recovers unpaid invoices for healthcare and service businesses. Recover 20–40% of aging receivables and reduce overdue invoices without adding overhead."
        path="/ar-debt-collections"
      />
      <PageHero eyebrow={ar.hero.eyebrow} title={ar.hero.title} subtitle={ar.hero.subtitle} image={images[ar.hero.image]} />

      <section className="container-x py-16 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <SectionHeading eyebrow="Turn overdue invoices into cash" title="Recover revenue without adding overhead" />
            <div className="mt-5 space-y-4">
              {ar.intro.map((p, i) => <p key={i} className="text-slate-600 leading-relaxed">{p}</p>)}
            </div>
          </div>
          <div className="grid gap-4 sm:grid-cols-3">
            {ar.stats.map((s) => <StatCard key={s.label} value={s.value} label={s.label} icon={s.icon} />)}
          </div>
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="container-x py-16 sm:py-20">
          <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
            <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
              <h3 className="text-2xl font-bold text-brand-navy">We help you</h3>
              <div className="mt-6"><CheckList items={ar.helps} /></div>
            </div>
            <div>
              <SectionHeading eyebrow="Who we serve" title="Structured follow-up for every industry" />
              <div className="mt-6 space-y-4">
                {ar.segments.map((s) => (
                  <div key={s.title} className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-600"><Icon name={s.icon} className="h-5 w-5" /></div>
                    <div>
                      <h4 className="text-base font-semibold text-brand-navy">{s.title}</h4>
                      <p className="mt-1 text-sm text-slate-600">{s.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTABand title="Stop revenue leakage from aging A/R" body="Let our team turn your overdue invoices into collected cash — with full transparency and performance-driven results." secondaryTo="/dental-orthodontics" secondaryLabel="For dental & ortho" />
    </>
  );
}
